import { createFileRoute, Link } from "@tanstack/react-router";
import { CountryPage, ratesQueryOptions, historyQueryOptions } from "@/components/CountryPage";
import { FaqSection } from "@/components/FaqSection";
import { SITE_URL, hreflangLinks, faqPageSchema } from "@/lib/seo";

const PATH = "/sone-ka-bhav-22-carat";
const TITLE = "22 Carat Sone Ka Bhav Aaj Ka — Live 22K Gold Rate India (916 Gold Per 10 Gram)";
const DESC = "22 carat sone ka bhav aaj ka live India — 916 gold rate per 10 gram, 1 gram, 1 tola. Delhi, Mumbai, Chennai, Jaipur, Lucknow, Nagpur ka 22K jewellery-grade rate, refreshed every 10 minutes.";

const FAQS = [
  { q: "22 carat sone ka bhav aaj ka kya hai?", a: "22 carat (91.67% pure / 916) sona India mein jewellery-grade standard hai. Aaj ka 22 carat sone ka bhav har city ke sarafa bazaar mein live is page par update hota hai — international XAU/USD spot + USD/INR ke hisaab se." },
  { q: "22 carat aur 24 carat sone mein kya farq hai?", a: "24 carat = 99.9% pure, soft, investment aur bullion ke liye. 22 carat = 91.67% pure (2 parts alloy for hardness), jewellery ke liye. Price 22 carat = 91.67% × 24 carat price + local premium." },
  { q: "916 sona kya hota hai?", a: "916 gold = 22 carat gold. Ye BIS hallmark stamp hai jo confirm karta hai purity 91.67% hai. Har India jewellery shop ne 916 stamp use karna zaroori hai." },
  { q: "22 carat sone ka bhav har city mein different kyun hota hai?", a: "Har city ke sarafa bazaar ka thoda different local premium hota hai — Delhi, Mumbai, Chennai ka slight difference. Basic spot rate same hota hai, sirf local demand-supply se ±0.3–1% ka fark hota hai." },
  { q: "1 tola 22 carat sone ka bhav?", a: "1 tola = 11.6638 gram. 1 tola 22 carat gold price = 22 carat per gram rate × 11.6638. Live per-tola rate is page par upar hai." },
  { q: "22 carat sone ka bhav Delhi mein aaj ka?", a: "Delhi ka 22 carat sone ka bhav Chandni Chowk / Karol Bagh sarafa bazaar reference se live hai. Direct Delhi city page se full breakdown mil jaayega." },
];

export const Route = createFileRoute("/sone-ka-bhav-22-carat")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESC },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESC },
      { property: "og:url", content: `${SITE_URL}${PATH}` },
      { property: "og:type", content: "website" },
      { property: "og:locale", content: "en_IN" },
    ],
    links: [{ rel: "canonical", href: `${SITE_URL}${PATH}` }, ...hreflangLinks(PATH)],
    scripts: [{ type: "application/ld+json", children: JSON.stringify(faqPageSchema(FAQS)) }],
  }),
  loader: ({ context }) => {
    void context.queryClient.prefetchQuery(ratesQueryOptions);
    void context.queryClient.prefetchQuery(historyQueryOptions("india"));
  },
  component: () => (
    <CountryPage
      country="india"
      title="22 Carat Sone Ka Bhav Aaj Ka — Live 22K Gold Rate India"
      intro="22 carat sone ka bhav aaj ka live India — 916 jewellery-grade gold rate har major city ke sarafa bazaar mein. Delhi, Mumbai, Chennai, Jaipur, Lucknow, Nagpur, Pune, Surat ka 22K per 10 gram, per gram, per tola rate — international spot + USD/INR se har 10 minute par refresh. 22 carat sabse popular jewellery karat hai India mein — 916 BIS hallmark iska proof hai."
      extras={
        <>
          <section className="mx-auto max-w-4xl px-4 pt-6">
            <div className="grid gap-3 sm:grid-cols-3">
              <Link to="/aaj-ka-sone-ka-bhav" className="rounded-xl border border-border bg-card p-4 hover:border-primary">
                <div className="font-semibold text-sm">Aaj ka sone ka bhav (all karats)</div>
                <div className="text-xs text-muted-foreground mt-1">24K + 22K + 18K live rate.</div>
              </Link>
              <Link to="/gold-rate-delhi" className="rounded-xl border border-border bg-card p-4 hover:border-primary">
                <div className="font-semibold text-sm">Delhi sone ka bhav</div>
                <div className="text-xs text-muted-foreground mt-1">Chandni Chowk sarafa reference rate.</div>
              </Link>
              <Link to="/gold-rate-mumbai" className="rounded-xl border border-border bg-card p-4 hover:border-primary">
                <div className="font-semibold text-sm">Mumbai sone ka bhav</div>
                <div className="text-xs text-muted-foreground mt-1">Zaveri Bazaar reference rate.</div>
              </Link>
            </div>
          </section>
          <FaqSection faqs={FAQS} title="22 carat sone ka bhav — FAQs" />
        </>
      }
    />
  ),
});